import { useTranslation } from 'react-i18next';

import { LegacyDialog, Props } from '../..';

import { useSxStyles } from './useStyles';

export const LegacyAlertDialog: React.FC<
  Omit<Props, 'showSave' | 'showCancel'>
> = ({ children, open, title, onClose }) => {
  const sxStyles = useSxStyles();
  const { t } = useTranslation();

  return (
    <LegacyDialog
      open={open}
      onClose={onClose}
      showSave={false}
      showCancel={true}
      hideTopClose={true}
      sxStylesDialogContent={sxStyles.content}
      sxStylesDialogPaper={sxStyles.paper}
      sxStylesDialogTitleToolbar={sxStyles.title}
      sxStylesDialogTitleText={sxStyles.titleText}
      customCancelText={`${t('laClose')}`}
      title={title}
    >
      {children}
    </LegacyDialog>
  );
};
